import store from '../store';
import getLeads from './GetLeads';

export const REFRESHING_LEADS = 'REFRESHING_LEADS';
export const REFRESHED_LEADS = 'REFRESHED_LEADS';

const refreshLeads = () => (
  () => {
    const { params } = store.getState().leads;
    store.dispatch(getLeads(params));
  }
);

export default refreshLeads;
